import React from 'react'
import PropTypes from 'prop-types'
import i18n from 'i18next'
import Text from '#components/a/Text'
import Headline from '#components/a/Headline'
import AusbildungsplanHeaderModal from './AusbildungsplanHeaderModal'

function FreigabeZurueckziehenButton(props) {
  const {freigabeZurueckziehen} = props
  return (
    <AusbildungsplanHeaderModal
      id="kapitel_freigabe_zurueckziehen_button"
      trigger={i18n.t('kapitel_freigabe_zurueckziehen_button')}
      variant="primary"
      modifiers={['zurueckziehen']}
      confirmCallback={freigabeZurueckziehen}
      confirmText={i18n.t('kapitel_freigabe_zurueckziehen_button')}>
      <Headline modifier="article" importance={2} text={i18n.t('kapitel_freigabe_zurueckziehen_modal_header')} />
      <Text modifier="small" text={i18n.t('kapitel_freigabe_zurueckziehen_modal_text')} />
    </AusbildungsplanHeaderModal>
  )
}

FreigabeZurueckziehenButton.propTypes = {
  freigabeZurueckziehen: PropTypes.func.isRequired,
}

export default FreigabeZurueckziehenButton
